import React from 'react'

const UtilityDrawerContent = () => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: '32px', paddingBottom: '32px' }}>
      <div>Placeholder Content</div>
    </div>
  )
}

export default UtilityDrawerContent